import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Collapse, Modal, Row, Col} from 'react-bootstrap';
import {NavBody, NavContent, SubMenuDiv, SubmitBtn} from '../../theme/MorsTheme';
import {RESPONSE} from '../../resources/constant';
import Idle from 'react-user-idle';

export default class Navigation extends Component{    	      
    constructor(props) {
        super(props);       
        this.modalShow = this.modalShow.bind(this); 
        this.modalHide = this.modalHide.bind(this);
        this.state = {
            menus: JSON.parse(localStorage.getItem(RESPONSE)),  
            open: false,
            show: false,                    
        };        
      }
    
    modalShow(event){       
        event.preventDefault();       
        this.setState({ show: true });         
    }

    modalHide(event) {
        event.preventDefault();      
        this.setState({ show: false,            
        });        
      }

          
    navList(data){                
        return data.map((menu, menuIndex) => {
            return <MenuList key={menuIndex} menuName={menu}>            
                    </MenuList>
            }        
        )
    }
    render(){       
        return(  
            <div>
                
            <Idle timeout={1200}
             throttle = {1}
             onChange={() => this.props.handleLogout()}> {() => this.props.handleLogout()}</Idle>
      
            <div>
               {this.navList(this.state.menus.mainMenu)}                            
            </div>
            
                       
            <Row style={{paddingTop: '10px',paddingLeft:'12px'}} className="d-none d-sm-block">
            <SubmitBtn onClick={this.modalShow}>LOG OUT</SubmitBtn>                                     
            </Row>


            <Modal  dialogClassName="modal-bdo" show={this.state.show} backdrop={'static'}  onHide={this.modalHide} centered={true} backdropClassName='fade'>                
                    <Modal.Header style={{backgroundColor:'#0B2972', height:'40px', padding:'15px, 0px'}}>                      
                        <Modal.Title style={{fontSize:'14px', color:'white'}}><span>Logout Confirmation</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >    
                        
                                <Row align="center">
                                    <Col>
                                    Are you sure you want to logout?                                     
                                    </Col>                                
                                </Row>
                                <Row align="center" style={{paddingTop: '10px'}}>
                                    <Col>
                                        <SubmitBtn onClick={()=> this.props.handleLogout()}>Yes</SubmitBtn>                                                                    
                                        <SubmitBtn onClick={this.modalHide}>No</SubmitBtn>    
                                    </Col>
                                </Row>                        
                    </Modal.Body>                                                               
            </Modal>  
            </div>                  
        )
    }
}

class MenuList extends Component{
    constructor(props){
        super(props)
        this.state = {
            open: false
            }            
    }    
    render(){
        return(                                             
            <NavBody>      
                {/*
                <NavContent><a onClick={() => this.setState({ open: !this.state.open })}>                                 
                    <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>                 
                    <span style={{color:'#FFB20C', fontWeight:'bold'}}>{this.props.menuName.mnmenuLabel}</span></a>
                </NavContent>       
                 */}
                {
                    ((this.props.menuName.mnmenuLabel === 'CUSTOMER SERVICE') ||
                     (this.props.menuName.mnmenuLabel === 'OTP GENERATOR') ||
                     (this.props.menuName.mnmenuLabel === 'ONLINE REPORTS'))?
                            null:              
                            <NavContent>
                                {/*<Link to={this.props.menuName} onClick={() => this.setState({ open: !this.state.open })}> */}
                                <Link to="/main" onClick={(e) => (this.setState({ open: !this.state.open }), (e.preventDefault()))}> 
                                <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>                 
                                <span style={{color:'#FFB20C', fontWeight:'bold'}}>
                                {this.props.menuName.mnmenuLabel}
                                </span>
                                </Link>                     
                            </NavContent>
                }

                {(typeof(this.props.menuName.subMenu)=='object')?this.props.menuName.subMenu.map((subrowdata, i)=>
                (subrowdata.submenuLabel === 'Customer Service Reports') ||
                (subrowdata.submenuLabel === 'Manage Main Menu') ||
                (subrowdata.submenuLabel === 'Manage Submenu') ||
                (subrowdata.submenuLabel === 'Group Profile') ||
                (subrowdata.submenuLabel === 'Group Access Maint') || 
                (subrowdata.submenuLabel === 'User Profile') || 
                (subrowdata.submenuLabel === 'Monitor Users') || 
                (subrowdata.submenuLabel === 'Audit Log') ?
                       null:                                                                                                          
                <Collapse in={this.state.open}>   
                    <SubMenuDiv>
                        {/*<Link to= onClick={() => this.setState({ open: !this.state.open })}> */}
                        <Link to={subrowdata.submenuUrl}  onClick={(e) => (this.setState({ open: !this.state.open }), e.preventDefault)}>
                        <span style={{color:'#FFFFFF'}}>{subrowdata.submenuLabel}                
                        </span></Link>                                                                    
                    </SubMenuDiv>                
                </Collapse>                        
                    )
                   :null}                                                      
            </NavBody> 

        )               
    }
}


